export function customToFixed(amount: number, decimalPlaces: number): string {
  const value = amount;
  if (isNaN(value) || value === Infinity) {
    return "0." + "0".repeat(decimalPlaces);
  }
  const factor = Math.pow(10, Number(decimalPlaces));
  const valueRound = Math.round((value + Number.EPSILON) * factor) / factor;
  return valueRound.toFixed(decimalPlaces);
}
